import React from 'react';
import CashierProductHandleButton, { CashierProductHandleType } from '../../components/CashierProductHandleButton';
import cashierService from 'modules/POS/services';
import { useAppDispatch } from 'store/hooks';

const CashierPromotionNew = () => {
  const dispatch = useAppDispatch();
  const promotion = cashierService.selectors.promotion();

  const toggle = () => {
    const nextValue = !promotion.active;
    if (nextValue) {
      dispatch(cashierService.actions.async.promotions.fetchPaging());
    }
    dispatch(cashierService.actions.setActivePromotion(nextValue));
  };

  return (
    <>
      <CashierProductHandleButton onClick={toggle} active={promotion.active} type={CashierProductHandleType.PROMOTION} />
    </>
  );
};

export default CashierPromotionNew;
